import { AppDispatch, RootState } from 'app/store';
import { getAPI, putAPI } from 'services/api/apiAsync';
import { selectUserId } from 'services/user/userSelectors';
import { API_ENDPOINTS, GENERAL } from 'utils/constants';
import { selectToken } from 'services/session/sessionSelectors';
import { updateAlertsData, updateViewStatus } from './alertsSlice';

// fetch alerts
export function fetchUserAlerts(
  page: number,
  pageSize: number = GENERAL.alertsPerPage,
) {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const state = getState();
      const userId = selectUserId(state);
      const token = selectToken(state);
      const config = {
        url: API_ENDPOINTS.alerts,
        params: {
          userIds: userId,
          page,
          pageSize,
        },
        headers: {
          'X-XSRF-TOKEN': token,
        },
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(updateAlertsData(response));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

// update alert view status
export function updateUserViewedStatus(alertId: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.alerts}/${alertId}/read`,
      };

      const response = await dispatch(putAPI(config)).unwrap();
      dispatch(updateViewStatus(response?.id));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
